import './Footer.module.scss';

const Footer = () => {
    return (
        <div style={{fontFamily: "Rubik", opacity: 0.8, width: "100%", textAlign: "center", paddingTop: '5px', backgroundColor: "rgb(237, 237, 237)"}}>
            <p style={{fontSize: "12px", lineHeight: "24px"}}>
                {process.env.REACT_APP_TERMS_OF_SERVICE_URL && <a href={process.env.REACT_APP_TERMS_OF_SERVICE_URL} target="_blank" rel="noreferrer">Terms of service</a>}&nbsp;
                <a href={process.env.REACT_APP_PRIVACY_POLICY_URL} target="_blank" rel="noreferrer">Privacy Policy</a>&nbsp;
                {process.env.REACT_APP_COOKIE_POLICY_URL && <a href={process.env.REACT_APP_COOKIE_POLICY_URL} target="_blank" rel="noreferrer" >Cookie Policy</a>}
                {process.env.REACT_APP_SWEEPSTAKES_RULES_URL && <a href={process.env.REACT_APP_SWEEPSTAKES_RULES_URL} target="_blank" rel="noreferrer" >Sweepstakes Rules</a>}
                <br/>Powered by <a href="https://www.actv8me.com" target="_blank" rel="noreferrer">ACTV8me</a>
            </p>            
        </div>
    )
}

export default Footer;